import React, { useState, useEffect, useMemo } from 'react';
import ParamClickable from './paramClickable';
import { containsUnique, getCategories, getCategory } from './commandMap';
import CommandParams from './commandParams';
import DropdownProperty from '../../../properties/DropdownProperty';
import { StoreActions } from '../../../../state/store';
import { useTypedDispatch, useTypedSelector } from '../../../../state/hooks';
import { IDropdownOption } from '../../../../interfaces/Misc';

interface ICommandTemplateProps
{
	file: string;
	index: number;
	operations: any[];
	operation: any;
	onChangeCallback?: (operation: any) => void;
}

export default function CommandTemplate(props: ICommandTemplateProps)
{
	const dispatch = useTypedDispatch();
	const currentCommand = useTypedSelector(state => state.revisionModule.operations[props.file])[props.index].command;
	const flattenedConfig = useTypedSelector(state => state.userModule.sessionInfo?.serverOptions.flattenedConfig);
	
	const [category, setCategory] = useState(currentCommand ? getCategory(currentCommand) : getCategories()[0]);

	useEffect(()=>
	{
		if(currentCommand && getCategory(currentCommand) !== category)
		    dispatch(StoreActions.revision.setItemCommand({ file:props.file, operationIndex:props.index, command: null, commandParams: null }));
	}, [category]);

	const nodeNames = (() =>
	{
		let result = "";
		if(props.operation && props.operation.nodes.length > 0)
		{
			for(let i = 0; i < props.operation.nodes.length; i++)
			{
				if(i < props.operation.nodes.length -1)
				{
					result+= props.operation.nodes[i].name +", ";
				}
				else 
				{
					result+= props.operation.nodes[i].name;
				}
			}
		}
		if( result === "") result = 'Click to select nodes';
		return result;
	})();

	const categoryOptions = useMemo(() => 
	{
		if(!flattenedConfig) return [];

		const options = new Array<IDropdownOption>();
		for(const category of getCategories())
		{
			const uniques = containsUnique(props.operations);
			const commandOptions = new Array<IDropdownOption>();
			for(const key of flattenedConfig.commandCategories[category])
			{
				let restricted = false;
				for(const unique of uniques)
				{
					if(flattenedConfig.uniqueGroups[unique].includes(key) && !flattenedConfig.uniqueGroups[unique].includes(currentCommand))
					{
						restricted = true;
					}
				}
    
				if(!restricted)
				{
					commandOptions.push({ display: flattenedConfig.commandList[key], value: key });
				}
			}
			if(commandOptions.length <= 0) continue;
			options.push({ display: category, value: category });
		}
		return options;
	}, [flattenedConfig, props.operations]);

	const categoryCommands = useMemo(() => 
	{
		if(!category || !flattenedConfig) return [];

		const uniques = containsUnique(props.operations);
		const commandOptions = new Array<IDropdownOption>();
		for(const key of flattenedConfig.commandCategories[category])
		{
			let restricted = false;
			for(const unique of uniques)
			{
				if(flattenedConfig.uniqueGroups[unique].includes(key) && !flattenedConfig.uniqueGroups[unique].includes(currentCommand))
				{
					restricted = true;
				}
			}

			if(!restricted)
			{
				commandOptions.push({ display: flattenedConfig.commandList[key], value: key });
			}
		}
		return commandOptions;
	}, [category, flattenedConfig, props.operations]);

	//render
	return (
		<>
			<div style={{
				color:'white', 
				marginBottom:'5px',
			}}>
				{/* TODO: figure out what the `param` here is supposed to be. it was set to `true` but is expected as an object... */}
         Nodes: [<ParamClickable {...props} param={{ id: "" }} name={nodeNames} onChangeCallback={props.onChangeCallback}/>]
			</div>
			<DropdownProperty data-name={"property-revision-category"}
				value={category}
				label="Category"
				options={categoryOptions}
				onChangeCallback={(v)=>{setCategory(v)}}
			/>
			<DropdownProperty 
				label={'Command:'}
				options={categoryCommands}
				value={currentCommand}
				onChangeCallback={(v) =>
				{
					console.log('setting current command');
					dispatch(StoreActions.revision.setItemCommand({ file:props.file, operationIndex:props.index, command: v, commandParams: flattenedConfig?.commandParams[v] }));
				}}/>
			<CommandParams {...props} params={flattenedConfig?.commandParams[currentCommand] || []}/>
		</>
	)
}